import React from "react";
import { formatLabel, getPaymentStatusStyles } from "../../utils/paymentHelpers";

const PaymentStatusBadge = ({ status, className = "" }) => {
  const styles = getPaymentStatusStyles(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ring-1 whitespace-nowrap ${styles.bg} ${styles.text} ${styles.ring} ${className}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${styles.dot}`} />
      {formatLabel(status) || "Unknown"}
    </span>
  );
};

export default PaymentStatusBadge;
